import { LookupCombobox } from '@/components/ui/lookup-combobox';
import { useT } from '@/i18n/LanguageContext';

/**
 * <MakerPicker> — メーカー（仕様 2.1）。
 *
 * 既にあるメーカーマスタ（`/api/lookups/makers`）を使う。新しいマスタは作らない。
 * 未登録のメーカーでも登録は止めない（自由入力で確定でき、権限があれば
 * その場でマスタに追加できる）。
 */
export const MakerPicker = ({ value = '', onChange, testId = 'maker-picker', placeholder = null }) => {
  const { t } = useT();
  return (
    <LookupCombobox kind="makers" value={value || ''} onChange={onChange}
      testId={testId} inputClassName="mt-1 h-10 text-sm"
      placeholder={placeholder || t('reg.maker.ph')} />
  );
};

export default MakerPicker;
